export const mediaViewer = {
  "App.app": "App",
};
